import React from "react";
import Navbar from "../components/Navbar/Navbar";
import FloatingIcons from "../components/FloatingIcons/FloatingIcons";
import Hero from "../components/Hero/Hero";
import InfoSection from "../components/InfoSection/InfoSection";
import StatsSection from "../components/StatsSection/StatsSection";
import MultiplySection from "../components/MultiplySection/MultiplySection";
import ImpactSection from "../components/ImpactSection/ImpactSection";
import AssociationSection from "../components/AssociationSection/AssociationSection";
import TestimonialsSection from "../components/TestimonialsSection/TestimonialsSection";
import WhyUsSection from "../components/WhyUsSection/WhyUsSection";
import JourneySection from "../components/JourneySection/JourneySection";
// import CTASection from "../components/CTASection/CTASection";
import Footer from "../components/Footer/Footer";
import { ClientIssue } from "../components/ClientIssue/ClientIssue";

const Home = () => {
  return (
    <>
      <div className="wc-ui-ambient-glow"></div>
      {/* <FloatingIcons /> */}
      <Navbar />
      <main>
        <Hero />
        {/* <StatsSection /> */}
        <ClientIssue />
        <MultiplySection />
        <JourneySection />
        <AssociationSection />
        {/* <ImpactSection /> */}
        <TestimonialsSection />
        <WhyUsSection />
        <InfoSection />
        {/* <CTASection /> */}
        <Footer />
      </main>
    </>
  );
};

export default Home;
